;
(function(){

  if(!window.USRS_COMMA_DECIMALS_MONEY){
    return;
  }
  // [formatMoney] Fix
  const originalFormatMoney = themeVendor.themeCurrency.formatMoney;
  themeVendor.themeCurrency = Object.freeze({
    ...themeVendor.themeCurrency,
    formatMoney: function(t, e) {
      return (isNaN(t) || null == t) ? '0' : String(originalFormatMoney(t, e)).replace(/\./g,'_decimal_point_').replace(/\,/g,'.').replace(/_point_/g,',');
    }
  });

  // [apps/wishlist moneyFormat] Fix
  if (window.location.pathname === '/apps/wishlist' || window.location.pathname === '/apps/wishlist/') {
    document.addEventListener('DOMContentLoaded', function() {
      const wishlistPage = document.querySelector('.wishlist-page');
      if(wishlistPage){
        let formatMoney = (typeof(window.theme) === 'undefined') ? function(price) {
          return originalFormatMoney(price,'${{amount_no_decimals}}');
        } : function(price) {
          return themeVendor.themeCurrency.formatMoney(price, theme.settings.currency_code_enable ? theme.moneyWithCurrencyFormat : theme.moneyFormat);
        }
        let processWishlistFormatMoney = function() {
          wishlistPage.querySelectorAll('.wishlist-price').forEach(wishlistPriceDiv => {
            if (!wishlistPriceDiv.hasAttribute('data-money-format-modified')) {
              let price = wishlistPriceDiv.getAttribute('data-price');
              if(price){
                let priceRemaster = `${price}.00`;
                let priceRemake = formatMoney(priceRemaster);
                wishlistPriceDiv.querySelectorAll('.money').forEach(moneySpan => {
                  moneySpan.textContent = priceRemake;
                });                  
              }
              wishlistPriceDiv.setAttribute('data-money-format-modified', 'true');
            }
          });
        }
        let debounceTimer = 0;
        new MutationObserver((mutationsList, observer) => {
          if (debounceTimer){
            clearTimeout(debounceTimer);
          } 
          debounceTimer = setTimeout(() => {
            mutationsList.forEach(mutation => {
              if (mutation.type === 'childList' || mutation.type === 'subtree') {
                if ('requestIdleCallback' in window) {
                  requestIdleCallback(() => {
                    processWishlistFormatMoney();
                  }, { timeout: 500 });
                } else {
                  processWishlistFormatMoney();
                }
              }
            });
          }, 16.7);
        }).observe(wishlistPage, {childList: true,subtree: true});
      }
    });
  }

})();
  
// [cart.updateItemsQuantity] Fix
document.addEventListener('DOMContentLoaded', function() {
  const checkIntervalTime = 100;
  let availableWaitingTime = 10000;
  const checkCart = function() {
    if (window.cart) {
      cart.originalUpdateItemsQuantity = cart.updateItemsQuantity;
      cart.updateItemsQuantity = function(itemsQty) {
        cart.originalUpdateItemsQuantity(itemsQty);
        document.querySelectorAll('[data-custom-cart-items-qty]').forEach(el=>{
          el.textContent = itemsQty;
        });
      }
    } else {
      availableWaitingTime -= checkIntervalTime;
      if (availableWaitingTime > 0) {
        setTimeout(checkCart, checkIntervalTime);
      } else {
        console.log('window.cart not found within the timeout period');
      }
    }
  };
  checkCart();
});
